"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const AssertionError_1 = require("../error/AssertionError");
class Exceptional {
    constructor(value, exception) {
        this.value = value;
        this.exception = exception;
        if ((value == null) == (exception == null)) {
            throw new AssertionError_1.default("Value and exception cannot both be initialized or both be null.");
        }
    }
    static getDefaultException() {
        return new Error();
    }
    static empty(exception = Exceptional.getDefaultException()) {
        return Exceptional.ofNullable(null, exception);
    }
    filter(predicate, value = t => Exceptional.getDefaultException()) {
        return this.isPresent()
            ? (predicate(this.value)
                ? this
                : Exceptional.ofNullable(null, value instanceof Error
                    ? value
                    : value(this.value)))
            : this;
    }
    flatMap(mapper) {
        return this.isPresent()
            ? mapper(this.get())
            : Exceptional.empty();
    }
    get() {
        if (!this.isPresent()) {
            throw this.exception;
        }
        return this.value;
    }
    ifPresent(consumer) {
        if (this.isPresent()) {
            consumer(this.value);
        }
    }
    isPresent() {
        return this.value != null;
    }
    map(mapper, value = t => Exceptional.getDefaultException()) {
        if (!this.isPresent()) {
            return Exceptional.empty(value instanceof Error
                ? value
                : value(this.value));
        }
        const u = mapper(this.value);
        return Exceptional.ofNullable(u, u == null
            ? value instanceof Error
                ? value
                : value(this.value)
            : null);
    }
    static of(value, exception = Exceptional.getDefaultException()) {
        if (value == null) {
            throw exception;
        }
        return new Exceptional(value, null);
    }
    static ofNullable(value, exception = Exceptional.getDefaultException()) {
        return new Exceptional(value, value == null ? exception : null);
    }
    orElse(other) {
        return this.isPresent()
            ? this.value
            : other;
    }
    orElseGet(other) {
        return this.isPresent()
            ? this.value
            : other();
    }
    orElseThrow(exceptionSupplier) {
        if (!this.isPresent()) {
            throw exceptionSupplier();
        }
        return this.value;
    }
    getException() {
        return this.exception;
    }
    withException(exception) {
        return this.isPresent()
            ? this
            : Exceptional.empty(exception);
    }
}
exports.default = Exceptional;
